
import { Button } from "@/components/ui/button";
import { TestTube } from "lucide-react";
import { Link } from "react-router-dom";

export const PluginTestingLink = () => {
  return (
    <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="font-medium text-green-900 mb-1">Test Your Plugin Setup</h4>
          <p className="text-sm text-green-700">
            Verify that your WordPress plugin is installed and working correctly.
          </p>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/plugin-testing">
            <TestTube className="mr-2 h-4 w-4" />
            Test Plugin
          </Link>
        </Button>
      </div>
    </div>
  );
};
